.ds-product-list {
  margin: 0 auto;
  display: block;
}
